<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         [selectable]="false">
    <ui-grid-header [search]="true">
        <ui-header-button type="main">
            <ng-template>
                <button *ngIf="showUploadButton"
                        [uiAuthorize]="createPermission"
                        [matTooltip]="type + '_grid_action_upload' | translate"
                        (click)="openUploadModal()"
                        mat-mini-fab
                        color="primary"
                        data-cy="nuget-upload">
                    <mat-icon>file_upload</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>
    <ui-grid-column [visible]="false"
                    [searchable]="true"
                    property="key">
    </ui-grid-column>
    <ui-grid-column [title]="type + '_grid_name' | translate"
                    [sortable]="true"
                    [primary]="true"
                    property="id"
                    asc="asc"
                    width="40%">
    </ui-grid-column>
    <ui-grid-column [title]="type + '_grid_description' | translate"
                    property="description"
                    width="30%">
    </ui-grid-column>
    <ui-grid-column [title]="type + '_grid_published' | translate"
                    property="published"
                    width="30%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #publishedFormat
                           [matTooltip]="publishedFormat?.dataset['title']"
                           [date]="entry.published"
                           contentType="relative"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button *ngIf="showViewer"
                    [matTooltip]="'packages_grid_view_explore_package' | translate "
                    (click)="openNugetViewerModal(entry)"
                    mat-icon-button
                    data-cy="open-nuget-viewer"
                    type="button">
                <mat-icon>device_hub</mat-icon>
            </button>
            <button [matTooltip]="type + '_grid_view_versions_tooltip' | translate"
                    (click)="showVersions(entry)"
                    mat-icon-button
                    data-cy="nuget-view-versions">
                <mat-icon>format_list_numbered</mat-icon>
            </button>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
